<template>
  <selector
    draggable-group="choices"
    item-name-plural="choices"
    item-name="choice"
    v-model="choiceList"
    :category-list="choiceCategoryList"
    :disabled-ids="selectorDisabledChoiceIds"
    :is-fixed="isFixed"
    :is-editable="isEditable"
    :search-text="selectorChoiceSearchText"
    :selected-category-id="selectorSelectedChoiceCategory"
    @onItemAdd="handleAddChoice"
    @onChangeCategory="handleSelectCategory"
    @onLoadMore="handleLoadMore"
    @onResetFilters="handleResetFilters"
    @onChangeSearchText="handleSearchText"
  ></selector>
</template>

<script>
import { debounce } from 'lodash';
import { mapGetters, mapState } from 'vuex';

import * as surveyBuilderTypes from '@/store/modules/surveybuilder/mutation-types';

import Selector from './Selector';

const DEBOUNCE_DELAY = 600;

export default {
  name: 'ChoiceSelector',
  components: {
    Selector,
  },
  props: {
    isFixed: {
      type: Boolean,
      default: false,
    },
    isEditable: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapState('surveybuilder', [
      'choiceList',
      'choicesLoading',
      'choiceCategoryList',
      'selectorSelectedChoiceCategory',
      'selectorChoiceSearchText',
    ]),
    ...mapGetters('surveybuilder', ['canvasSelectedQuestion', 'selectorDisabledChoiceIds']),

    sortedChoiceList() {
      // TODO: BACKEND
      const question = this.canvasSelectedQuestion;
      const choices = [...this.choiceList];
      if (!question) {
        return choices.sort((a, b) => a.title - b.title);
      }

      const words = question.title.toLowerCase().split(' ');
      const hasKeywords = keywords =>
        keywords.map(k => k.toLowerCase()).some(k => words.includes(k));

      const sortedChoices = choices.sort((a, b) => {
        let aScore = 0;
        let bScore = 0;

        // Times used
        const aUsed = (a.usedWith || {})[question.id] || 0;
        const bUsed = (b.usedWith || {})[question.id] || 0;
        aScore += aUsed > bUsed ? 5 : 0;
        bScore += bUsed > aUsed ? 5 : 0;

        // Keywords
        aScore += hasKeywords(a.keywords || []) ? 3 : 0;
        bScore += hasKeywords(b.keywords || []) ? 3 : 0;

        // Alphabetical
        aScore += a.title < b.title ? 1 : 0;
        bScore += b.title < a.title ? 1 : 0;

        return bScore - aScore;
      });
      return sortedChoices;
    },
  },
  methods: {
    handleAddChoice(choice) {
      this.$store.dispatch('surveybuilder/canvasAddChoice', choice);
    },

    handleSelectCategory(categoryId) {
      this.$store.dispatch('surveybuilder/selectorSelectChoiceCategory', categoryId);
      this.$store.dispatch('surveybuilder/getChoices');
    },

    handleSearchText(text) {
      this.$store.commit(`surveybuilder/${surveyBuilderTypes.SET_SELECTOR_CHOICE_TEXT}`, text);
      this.handleDebounceGetChoices(text);
    },

    handleResetFilters() {
      this.$store.commit(`surveybuilder/${surveyBuilderTypes.RESET_SELECTOR_CHOICE_FILTERS}`);
      this.$store.dispatch('surveybuilder/getChoices');
    },

    // eslint-disable-next-line
    handleDebounceGetChoices: debounce(function(text) {
      this.$store.dispatch('surveybuilder/getChoices');
    }, DEBOUNCE_DELAY),

    handleLoadMore() {
      // Make sure we have actual choices before we can try load more.
      if (this.choiceList.length && !this.choicesLoading) {
        this.$store.dispatch('surveybuilder/getMoreChoices');
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// ChoiceSelector.vue?f5e6f68c